import React, { Component, createRef } from "react";
import {
  GET,
  POST,
  loading,
  token,
  profile,
  alert,
  params,
} from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import LOGO from "../assets/images/logo-w.png";

import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: global.mobile[Number(params("id"))] || null,
      id: "",
      select_package: "",
      select_payment: ""
    };
  }
  async componentDidMount() {
    loading(false);
  }
   Payment = async () => {
    const { data, id_game, select_package } = this.state;
    if (profile) {
      if (id_game === "") {
        alert("", "warning", "แจ้งเตือน", "กรุณากรอก id game");
        return;
      }
      if (select_package === "") {
        alert("", "warning", "แจ้งเตือน", "กรุณาเลือกแพ็คเกจ");
        return;
      }
      await fetch(
        `${
          "https://swiftgamepay-default-rtdb.asia-southeast1.firebasedatabase.app/"
        }payment_mobile/${new Date().getTime()}.json`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            package: data?.package[select_package],
            payment: data?.name,
            fee: global.payment.find(e=>e.name === data?.name)?.fee,
            price:
              Number(
                data?.package[select_package]?.new_price.replaceAll(",", "")
              ) +
                Number(
                  data?.package[select_package]?.new_price.replaceAll(",", "")
                ) *
                  global.payment.find(e=>e.name === data?.name)?.fee || 0,
          }),
        }
      );
      await alert("login", "success", "สำเร็จ", "QR code การชำระเงิน ถูกส่งไปทางอีเมลที่ท่านได้ลงทะเบียนไว้ กรุณาชำระเงินภายใน 30 นาที");
      window.location.href = "/"
    } else {
      alert("", "warning", "แจ้งเตือน", "กรุณาเข้าสู่ระบบก่อนทำรายการ");
      return;
    }
  };
  render() {
    const { data, id, select_package, select_payment } = this.state;
    return (
      <div className="w-100 min-vh-100 bg-dark position-relative">
        <Navbar />
        <div className="container mx-auto my-5">
          <div className="row">
            <div className="col-12 col-lg-8">
              <div className="mx-auto d-flex bg-white rounded-4 mb-3 position-relative">
                <img
                 src={require(`../assets/images/mobile/image-${Number(params("id")) + 1}.jpg`)}
                  alt=""
                  className="wpx-300 hpx-300 me-4 rounded-4"
                  style={{objectFit:"contain"}}
                />
                <div
                  className="wpx-50 hpx-300 position-absolute"
                  style={{
                    left: 250,
                    background: "#000000ff",
                    background:
                      "linear-gradient(90deg,rgba(0, 0, 0, 0) 0%, rgba(255, 255, 255, 1) 100%)",
                  }}
                ></div>
                <div className="p-3">
                  <h1 className="fw-bold mb-4">{data?.name || ""}</h1>
                  <div className="mb-2 d-flex flex-column">
                     สามารถเติม coin<br/>
                  ผ่าน {data?.name || ""}<br/>
                  ค่าธรรมเนียมการเติมเงิน : {(global.payment.find(e=>e.name === data?.name)?.fee || 0) * 100}% (ค่าบริการ)
                  </div>
                </div>
              </div>
              <div className="row">
                {data?.package?.map((item, index) => (
                  <div className="col-12 col-sm-6 col-md-4 col-xl-3 mb-3">
                    <div
                      className={`mx-auto ${
                        select_package === index
                          ? "bg-primary-light border-0 border-info"
                          : "bg-white border-0"
                      } rounded-4 overflow-hidden pointer product`}
                      onClick={() => {
                        this.setState({ select_package: index });
                      }}
                    >
                      <div className="w-100 hpx-90 p-3">
                        <h6
                          className="fw-bold w-100 overflow-hidden mb-0 text-nowrap mb-2"
                          style={{ textOverflow: "ellipsis" }}
                        >
                          {item.name || ""}
                        </h6>
                        <div className="d-flex">
                          <h5
                            className="text-info fw-bold"
                            style={{ textOverflow: "ellipsis" }}
                          >
                            ฿ {item.new_price || "-"}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="p-3 mx-auto bg-white rounded-4">
                <div className="d-flex justify-content-between">
                    <span>ราคาสินค้า</span>
                    <span>{(Number(data?.package[select_package]?.new_price.replaceAll(",","")) || 0)?.toFixed(2)}</span>
                  </div>
                  <hr/>
                  <div className="d-flex justify-content-between">
                    <span>ช่องทางการชำระเงิน</span>
                    <span>{global.payment.find(e=>e.name === data?.name)?.name || "-"}</span>
                  </div>
                  <hr/>
                  <div className="d-flex justify-content-between">
                    <span>ค่าบริการ</span>
                    <span>{((Number(data?.package[select_package]?.new_price.replaceAll(",","")) * global.payment.find(e=>e.name === data?.name)?.fee) || 0)?.toFixed(2)}</span>
                  </div>
                  <hr/>
                  <div className="d-flex justify-content-between mb-3">
                    <span>จำนวนเงินที่ชำระ</span>
                    <span>{((Number(data?.package[select_package]?.new_price.replaceAll(",","")) + (Number(data?.package[select_package]?.new_price.replaceAll(",","")) * global.payment.find(e=>e.name === data?.name)?.fee))||0)?.toFixed(2)}</span>
                  </div> <button className="btn btn-primary w-100" onClick={() => {this.Payment()}}>ชำระเงิน</button>
              </div>
            </div>
          </div>
        </div>
        <div className="w-100 align-content-center text-dark pb-5">
          <div className="container mx-auto">
        <div className="w-100 mb-5 p-3 border-1 rounded-4 bg-light">
            <h5>หมายเหตุ</h5>
            <ul>
              <li>เมื่อชำระเงินผ่าน {data?.name || ""} สำเร็จแล้ว จะไม่สามารถยกเลิกได้</li>
              <li>สามารถเติมเงินขั้นต่ำได้ 20 บาทขึ้นไป</li>
              <li>เมื่อชำระเงินจะมีค่าธรรมเนียม {(global.payment.find(e=>e.name === data?.name)?.fee || 0) * 100}%</li>
              <li>1 วันสามารถเติมเงินได้สูงสุด 2 ล้านบาท</li>
              <li>coin ที่เติมเข้ามา สามารถใช้เติมเกม ซื้อบัตรเติมเงิน และขอคืนเงินได้</li>
              <li>1 coin มีมูลค่าเท่ากับ 1 บาท</li>
            </ul>
          </div>
          </div>
          </div>
        <Footer />
      </div>
    );
  }
}
